export const calendarQueryKeys = {
  all: ["calendar"],
  yearAndMonth: (yearAndMonth: string) => [...calendarQueryKeys.all, yearAndMonth],
} as const;
